import { Grid } from '@material-ui/core';
import { withTheme } from '@material-ui/styles';
import FullScreenLoader from 'components/Loaders/FullScreenLoader';
import Page from 'components/Page';
import { useActions } from 'helpers/useActions';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getNewsPostsAction } from './actions';
import NewsPostCard from './postCard/NewsPostCard';
import HeaderBanner from 'components/headerBanner/HeaderBanner';

function NewsPosts({ history, theme }) {
  const getNewsPosts = useActions(getNewsPostsAction);
  const authUser = useSelector(state => state.authState.firestoreUser);
  const posts = useSelector(state => state.newsState.posts);
  const loading = useSelector(state => state.newsState.loading);

  useEffect(() => {
    if (authUser && posts.length < 1) {
      getNewsPosts();
    }
  }, [authUser, getNewsPosts, posts]);
  if (loading) return <FullScreenLoader />;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <HeaderBanner title="News" subtitle="It's all about news" />

      <Page>
        <Grid container spacing={4}>
          {Object.values(posts).map(post => {
            return (
              <React.Fragment key={post.newsKey}>
                <Grid item xs={4} style={{ marginLeft: '12%' }}>
                  <NewsPostCard
                    post={post}
                    key={post.newsKey}
                    push={() => history.push('/news/' + post.newsKey)}
                    anon={authUser.isAnonymous || false}
                  />
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
      </Page>
    </div>
  );
}

export default withTheme(NewsPosts);
